import React from 'react';
import Header from '../common/Header';

import PLANE from '../assets/img/about_airplane.png';
import Footer from '../common/Footer';
import usePageTracking from '../lib/usePageTracking';

import TravelIcon from '../assets/img/travel-icon.svg';
import TravelIcon2 from '../assets/img/travel-icon-2.svg';
import TravelIcon3 from '../assets/img/travel-icon-3.svg';
import TravelIcon4 from '../assets/img/travel-icon-4.svg';

const About = () => {
  usePageTracking();

  return (
    <div>
      <div className="header-wrapepr">
        <Header />
      </div>
      <div className="overlay">
        <div className="header-image-container">
          <div>
            <h1>تعرَّف أكثر على كويندا</h1>
            <p>بكل فخر، تم تصميم وتطوير منصة كويندا من قبل فريق سوداني يمتلك شغفًا كبيرا بالإبتكار وخبرة جماعية تزيد عن 50 عامًا.</p>
            <p>كلمة "كويندا" تعني "هيا بنا" باللغة السواحيلية، وتُجسد دعوتنا لكم للانطلاق في رحلات سلسة ومريحة عبر منصتنا. مع كويندا، نوفر لكم حلولاً شاملة لكل إحتياجات السفر والترحال حول العالم، بلمسة زر واحدة من أي مكان.</p>
          </div>
        </div>
      </div>
      <div className="about-page-wrapper">
        <div className="about-intro">
          <p>
            تأسست كويندا في أوائل عام 2023 تحت مظلة <a href="https://eptikar.com">(شركة ابتكار آي تي سوليوشنز)</a>، عبر فريق مميز يعمل برؤية واضحة تجمع بين خبرات الطيران والسفر والسياحة، وكفاءة رائدة في تطوير البرمجيات. لنقدم حلولاً وخدمات سفر متكاملة للشركات والأفراد، مع التركيز على تقديم تجربة مبتكرة تلبي أعلى معايير الجودة وتوفر الراحة والقيمة لعملائنا.
          </p>
        </div>
        <div className="about-content">
          <img src={TravelIcon} />
          <div>
            <h2>منصة سفر متكاملة الخدمات</h2>
            <p>في كويندا، نسعى لتوفير خيارات سفر مميزة لا تجدها بسهولة في أماكن أخرى، مما يمنح عملاءنا الثقة بأن أفضل الخيارات التي تلبي احتياجاتهم متاحة بسهولة وفي متناول أيديهم.</p>
          </div>
        </div>
        <div className="about-content">
          <img src={TravelIcon2} />
          <div>
            <h2>كن انت وكالة السفر</h2>
            <p>نحن نشاركك حب السفر والمغامرة. ندرك أن العالم مليء بالأماكن الرائعة والتجارب الفريدة التي تستحق الاستكشاف. لذا، نقدم لك أفضل الأسعار، والوجهات، والنصائح لرحلتك. مع كويندا، أنت تختار متى وأين وكيف تسافر بحرية تامة.</p>
          </div>
        </div>
        <div className="about-content">
          <img src={TravelIcon3} />
          <div>
            <h2>تجربة حجز تتجاوز التوقعات</h2>
            <p>نحول عملية الحجز من مهمة مرهقة وعشوائية قد تستنزف الوقت والمال إلى تجربة سهلة وممتعة. نقدم لك مجموعة واسعة من الخيارات وعروضًا مميزة من أفضل شركات الطيران، لتختار بثقة وراحة ما يناسب احتياجاتك وتطلعاتك.مع منصتنا المتطورة التي لاتتوقف عن التحديث والتجديد، يصبح الحجز بسيطًا وآمنًا، مع ضمان أعلى مستويات المرونة والراحة. لا نتوقف عند تسهيل الحجز فقط، بل نسعى لأن تكون هذه الخطوة الأولى في رحلة مليئة بالراحة والذكريات السعيدة.مع كويندا، تبدأ رحلتك بابتسامة وتنتهي بتجربة لا تُنسى.
            </p>
          </div>
        </div>
        <div className="about-content">
          <img src={TravelIcon4} />
          <div>
            <h2>أسعار وعروض مميزة</h2>
            <p>نفخر باستقلاليتنا ونسعى مدعومين بثقة عملائنا لتحدي الجمود في نظام شركات الطيران والشركات الناقلة، بما يخدم مصالح عملائنا بأقصى حد. نبتكر حلولًا تجعل السفر ميسور التكلفة للجميع. ونسعى لتغيير طريقة السفر لبناء مجتمع أكثر انفتاحًا وتسامحًا.</p>
          </div>
        </div>
      </div>
      <div className="cta">
        <div>
          <h1>احجز مع كويندا، واكتشف الفرق</h1>
          <p>كويندا في مهمة لتقديم منصة سفر متكاملة الخدمات لعملاؤنا حول العالم، مع اهتمام خاص بعملائنا السودانيين والأفارقة.</p>
        </div>
        <img src={PLANE} width={200} />
      </div>
      <Footer />
    </div>
  );
};

export default About;
